<template>
  <div :class="['modal', 'fade', theme]" :id="id" tabindex="-1" role="dialog" :aria-labelledby="id + 'Label'" aria-hidden="true">
    <div :class="['modal-dialog', size]" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" :id="id + 'Label'">{{ title }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div :class="['form-group', field.class]" v-for="field in fields">
            <!-- message -->
            <label v-if="field.type !== 'message' && field.name" for="projectName">{{ field.name }}</label>
            <!-- input-text -->
            <input v-if="field.type === 'text'" type="text" class="hz-input-default hz-input-md"
                   style="width: 100%;" v-model="data[field.id]">
            <!-- textarea -->
            <textarea v-if="field.type === 'textarea'" class="form-control hz-input-default" rows="10" :placeholder="field.placeholder" v-model="data[field.id]"></textarea>
            <!-- HelpText -->
            <p v-if="field.helpText" class="help-block">{{ field.helpText }}</p>
            <p v-if="field.type === 'message'" v-for="message in field.message" style="margin: 0;"> {{ message }} </p>
          </div>
        </div>
        <div v-if="type === 'alert'" :class="['modal-footer', footer.class]">
          <button type="button" class="hz-btn-primary hz-btn-md" data-dismiss="modal" @click.prevent="submit">확인</button>
        </div>
        <div v-if="type === 'confirm'" :class="['modal-footer', footer.class]">
          <button type="button" :class="footer.cancel.class" data-dismiss="modal" @click.prevent="cancel">{{ footer.cancel.text }}</button>
          <button type="button" :class="footer.submit.class" data-dismiss="modal" @click.prevent="submit">{{ footer.submit.text }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'modal',
    props: {
      theme: {
        type: String,
        default: function () {
          return 'hz-modal-default'
        }
      },
      value: {
        type: Object,
        default: function () {
          return {}
        }
      },
      title: {
        type: String,
        default: function () {
          return ''
        }
      },
      id: {
        type: String,
        default: function () {
          return ''
        }
      },
      type: {
        type: String,
        default: function () {
          return 'alert'
        }
      },
      size: {
        type: String,
        default: function () {
          return 'modal-md'
        }
      },
      fields: {
        type: Array,
        default: function () {
          return []
        }
      },
      callBack: {
        type: String,
        default () {
          return ''
        }
      },
      footer: {
        type: Object,
        default: function () {
          return {
            class: 'text-align-center',
            submit: {
              text: '확인',
              class: 'hz-btn-primary hz-btn-md'
            },
            cancel: {
              text: '취소',
              class: 'hz-btn-default hz-btn-md'
            }
          }
        }
      }
    },
    data: function () {
      return {
        data: {}
      }
    },
    watch: {
      'value': {
        handler: function (val) {
          this.data = $.extend(true, {}, val)
        },
        deep: true
      }
    },
    computed: {},
    components: {},
    methods: {
      show: function () {
        $('#' + this.id).modal('show')
      },
      hide: function () {
        $('#' + this.id).modal('hide')
      },
      submit: function () {
        // 전달받은 콜백 함수명이 있을 경우, 해당 함수명으로 이벤트를 발생시킨다.
        const callBack = this.callBack ? this.callBack : 'submit'
        this.$emit(callBack, this.data)
      },
      cancel: function () {
        this.$emit('cancel')
      }
    },
    created: function () {
      this.data = $.extend(true, {}, this.value)
    },
    mounted: function () {},
    updated: function () {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .hz-modal-default {

    .modal-dialog {

      .modal-content {
        border-radius: 4px;

        .modal-header {
          padding: 24px;
          border: none;
          h5 {
            display: inline-block;
            margin: 0;
          }
          .close {
            font-size: 14px;
            color: $hzc-gray-06;
            opacity: initial;
          }
        }
        .modal-body {
          padding: 32px 24px;
          word-break: keep-all;
        }

        .modal-footer {
          padding: 24px;
          border: none;
          button {
            width: 100px;
          }
        }
      }

      .help-block {
        margin: 8px 0 0 0;
        color: $brand-info;
        font-size: 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ../common/components/Modal.vue